<template>
  <modal size="small">
    <div class="modal-header">
      <h4>แก้ไขรหัสผ่าน</h4>
      <div class="actions">
        <small class="text-danger mr-3"
          v-if="isServerError()">
            พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : {{errorStatus}}
          </small>
      </div>
    </div>
    <form @submit.prevent="updatePassword">
      <div class="modal-body">
        <div class="content">
          <div class="form-group-container">
            <FormGroup>
              <h5 class="name">รหัสผ่านใหม่</h5>
              <input
                type="password"
                v-model="user.password"
                class="form-control"
                :class="{'is-invalid': error.password}"
                @keyup="validatePassword"
                @blur="validatePassword"/>
              <div class="invalid-feedback">{{error.password}}</div>
            </FormGroup>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="onCloseModal" type="button" class="btn btn-outline-secondary mr-auto">
          ยกเลิก
        </button>
        <button type="submit" class="btn btn-primary" :disabled="!isValid">
          บันทึก
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import _ from 'lodash';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import { updateUserPassword } from './api';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    onCloseModal: {
      type: Function,
      default: () => {},
    },
    onChangePassword: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      user: {
        password: '',
      },
      error: {
        password: '',
      },
      errorStatus: null,
    };
  },
  components: {
    Modal,
    FormGroup,
  },
  computed: {
    isValid() {
      if (this.user.password === '') return false;
      return !this.error.password;
    },
    password() {
      return this.user.password;
    },
  },
  watch: {
    password() {
      this.validatePassword();
    },
  },
  methods: {
    async updatePassword() {
      try {
        await updateUserPassword(this.accountId, this.user);
        this.errorStatus = null;
        this.onChangePassword();
        this.onCloseModal();
      } catch (error) {
        this.errorStatus = error.response.status;
      }
    },
    isServerError() {
      return this.errorStatus && this.errorStatus !== 422;
    },
    validatePassword() {
      const password = _.get(this.user, 'password', null);
      if (!password) {
        this.error.password = 'กรุณาใส่รหัสผ่าน';
      } else if (!password.match(this.englishAlphabets) || password.length < 8) {
        this.error.password = 'กรุณาใช้รหัสผ่านที่มีตัวอักษรภาษาอังกฤษ และยาวไม่ต่ำกว่า 8 ตัว';
      } else {
        this.error.password = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
